import { Route, Switch } from "react-router-dom";

import Redirect from "modules/core/components/Redirect";
import Error404 from "modules/core/pages/Error404";

import { experimentsPrivateRoutesConstants } from "modules/experiments/routes/private/routesConstants";
import { insightsPrivateRoutesConstants } from "modules/insights/routes/private/routesConstants";
import { researchPrivateRoutesConstants } from "modules/research/routes/private/routesConstants";
import { ideasPrivateRoutesConstants } from "modules/ideas/routes/private/routesConstants";
import { experimentsPublicRoutesConstants } from "modules/experiments/routes/public/routesConstants";
import { coreRoutesConstants } from "modules/core/routes/routesConstants";
import { collaborationPublicRoutesConstants } from "modules/collaboration/routes/public/routesConstants";
import { authRoutesConstants } from "modules/auth/routes/routesConstants";

const LegacyRoutes = () => {
  return (
    <Switch>
      <Route
        exact
        path="/r/shared_experiments/:token"
        render={({ match }) => (
          <Redirect
            forceReload
            to={experimentsPublicRoutesConstants.shared_experiments.href(
              match.params.token
            )}
          />
        )}
      />
      <Route
        exact
        path="/r/shared_experiments/:id/variations_compare_view"
        render={({ match }) => (
          <Redirect
            forceReload
            to={experimentsPublicRoutesConstants.single_shared_experiment.href(
              match.params.id
            )}
          />
        )}
      />
      <Route
        exact
        path="/r/shared_experiments/:token/view/:id"
        render={({ match }) => (
          <Redirect
            to={experimentsPublicRoutesConstants.shared_experiment.href(
              match.params.token,
              match.params.id
            )}
            forceReload
          />
        )}
      />
      <Route
        exact
        path="/r/crowdsource/:token"
        render={({ match }) => (
          <Redirect
            forceReload
            to={collaborationPublicRoutesConstants.crowdsource.href(
              match.params.token
            )}
          />
        )}
      />
      <Route
        exact
        path="/r/crowdsource/:public_token/all"
        render={({ match }) => (
          <Redirect
            to={collaborationPublicRoutesConstants.crowdsource.href(
              match.params.public_token
            )}
            forceReload
          />
        )}
      />
      <Route
        exact
        path="/r/dashboard"
        render={() => (
          <Redirect
            to={coreRoutesConstants.dashboard.href("all")}
            forceReload
          />
        )}
      />
      <Route
        exact
        path="/r/projects/:id"
        render={({ match }) => (
          <Redirect
            forceReload
            to={coreRoutesConstants.dashboard.href(match.params.id)}
          />
        )}
      />
      <Route
        exact
        path="/r/research/:project_id"
        render={({ match }) => (
          <Redirect
            to={researchPrivateRoutesConstants.root.href(
              match.params.project_id
            )}
            forceReload
          />
        )}
      />
      <Route
        exact
        path="/r/ideas/:project_id"
        render={({ match }) => (
          <Redirect
            to={ideasPrivateRoutesConstants.root.href(match.params.project_id)}
            forceReload
          />
        )}
      />
      <Route
        exact
        path="/r/experiments/all"
        render={() => (
          <Redirect
            to={experimentsPrivateRoutesConstants.root.href("all")}
            forceReload
          />
        )}
      />
      <Route
        exact
        path="/r/experiments/:project_id"
        render={({ match }) => (
          <Redirect
            to={experimentsPrivateRoutesConstants.root.href(
              match.params.project_id
            )}
            forceReload
          />
        )}
      />
      <Route
        exact
        path="/r/project_groups"
        render={() => (
          <Redirect
            to={coreRoutesConstants.project_grouping.href("all")}
            forceReload
          />
        )}
      />
      <Route
        exact
        path="/r/research/:project_id/show/:research_id"
        render={({ match }) => (
          <Redirect
            to={researchPrivateRoutesConstants.single_research.href(
              Number(match.params.research_id),
              match.params.project_id
            )}
            forceReload
          />
        )}
      />
      <Route
        exact
        path="/r/search/:project_id/"
        render={({ match }) => (
          <Redirect
            to={insightsPrivateRoutesConstants.query_engine.href(
              match.params.project_id
            )}
            forceReload
          />
        )}
      />

      <Route
        exact
        path="/r/sign_in"
        render={() => (
          <Redirect to={authRoutesConstants.login.href()} forceReload />
        )}
      />

      <Route
        exact
        path="/r/change_password"
        render={() => (
          <Redirect
            to={authRoutesConstants.forgotPassword.href()}
            forceReload
          />
        )}
      />

      <Route render={() => <Error404 />} />
    </Switch>
  );
};

export default LegacyRoutes;
